import type { MenuItem, OptionGroup, SelectedOption } from '@/types';
import { resolveModePrice, type ConsumerMode } from './resolveModePrice';

export function computeUnitPrice(
  item: MenuItem,
  groups: OptionGroup[],
  selected: SelectedOption[],
  // SC-218 / SC-237: in a buffet dine-in session an "included" product's base
  // AND its options are 0 (the buffet entry fee covers everything). Options stay
  // selectable; they just add no supplement. Default false keeps every
  // à-la-carte / non-buffet caller byte-identical.
  isBuffetDineIn = false,
  // SC-250: the fulfillment mode selects the per-mode base price (item.pricesByMode)
  // so the modal / cart / checkout agree with the menu card and the server quote.
  // Omitted → falls back to the mode-agnostic item.price (existing callers unchanged).
  mode?: ConsumerMode,
): number {
  const buffetIncluded = isBuffetDineIn && !!item.includedInBuffet;
  const base = mode ? resolveModePrice(item, mode) : item.price;
  let total = buffetIncluded ? 0 : base;
  if (!buffetIncluded) {
    for (const sel of selected) {
      const group = groups.find((g) => g.id === sel.groupId);
      if (!group) continue;
      for (const entry of sel.options) {
        const opt = group.options.find((o) => o.id === entry.id);
        if (opt) total += opt.priceDelta * entry.qty;
      }
    }
  }
  return Math.max(0, total);
}
